import React from 'react';
import { formatDateLocal } from '../../../utility/utility_functions';

const propertySaborResoDisclaimer = (
  brokerageName: string,
  agentName: string,
  updatedAt: string
) => `Information provided by the San Antonio Board of REALTORS® (SABOR) MLS through the SABOR MLS RESO Web API. All information is deemed reliable but not guaranteed and should be independently verified by the consumer.

All properties are subject to prior sale, change, or withdrawal. Neither the listing broker, participating brokers, information providers, nor SABOR MLS make any representations or warranties regarding the accuracy, completeness, or reliability of the information displayed herein.

Listing information is provided exclusively for personal, non-commercial use and may not be used for any purpose other than to identify prospective properties consumers may be interested in purchasing. Any other use is strictly prohibited.

Listing courtesy of: ${brokerageName}
Listing Agent: ${agentName}

Data sourced from SABOR MLS via RESO Web API.
Data last updated on ${updatedAt}.

Copyright © 2026 San Antonio Board of REALTORS®. All rights reserved.`;

const propertyBrokerageDisclosure =
  () => `REIX Ventures, LLC is not a licensed real estate brokerage and does not provide real estate brokerage services, representation, or advice. REIX Ventures, LLC does not act as an agent for buyers or sellers.

All real estate brokerage services, representations, and listings are provided by licensed real estate brokers and agents participating in the SABOR MLS. Any inquiries regarding a specific property should be directed to the listing broker or a licensed real estate professional of the consumer’s choosing.

Broker participation in the IDX program does not imply endorsement of any property, brokerage, or platform by the San Antonio Board of REALTORS® or SABOR MLS.

Fair Housing Notice

Equal Housing Opportunity
This property is offered without regard to race, color, religion, sex, handicap, familial status, or national origin.`;

export const PropertyDisclaimer = ({
  brokerageName,
  agentName,
  updatedAt,
}: {
  brokerageName: string;
  agentName: string;
  updatedAt: string;
}) => {
  return (
    <div>
      <h3 className="font-bold">
        SABOR MLS / RESO IDX Disclaimer & Disclosure
      </h3>
      <p>
        {propertySaborResoDisclaimer(
          brokerageName,
          agentName,
          formatDateLocal(updatedAt)
        )}
      </p>
      <h3 className="font-bold mt-4">Platform & Brokerage Disclosure</h3>
      <p>{propertyBrokerageDisclosure()}</p>
    </div>
  );
};
